import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Page, Spinner } from "@/components/Layout";
import { Riepilogo } from "@/pages/Checkout";

export default function OrdineEsito() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const token = sp.get("t");
  const [o, setO] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let n = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/pubblico/ordini/${id}`, { params: { t: token } });
        setO(data);
        const attesa = data.stato === "in_attesa" && n < 40;
        if (attesa) {
          n += 1;
          timer = setTimeout(poll, 2500);
        }
      } catch (e) {
        setErr(errMsg(e));
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [id, token]);

  if (err) return <Page><div className="card text-center">{err}</div></Page>;
  if (!o) return <Spinner />;
  const fallito = o.stato === "fallito" || o.pi_status === "requires_payment_method";
  return (
    <Page className="max-w-4xl">
      <div className="grid md:grid-cols-5 gap-8 items-start">
        <div className="md:col-span-3 card text-center py-12" data-testid="order-status">
          {o.stato === "pagato" ? (
            <>
              <CheckCircle2 size={56} className="mx-auto text-emerald-700" />
              <h1 className="font-display text-4xl mt-4" data-testid="order-success">Grazie! Pagamento riuscito</h1>
              <p className="text-[#786E65] mt-3">La gift card è stata emessa. Ricevuta inviata a <strong>{o.acquirente_email}</strong>.
                {o.regalo ? ` La gift card arriverà a ${o.destinatario_email}${o.data_consegna ? " nella data scelta" : " a breve"}.` : " Riceverai il codice con il PDF via email."}</p>
              <Link to="/" className="btn-secondary mt-8">Torna al catalogo</Link>
            </>
          ) : fallito ? (
            <>
              <XCircle size={56} className="mx-auto text-red-700" />
              <h1 className="font-display text-4xl mt-4" data-testid="order-failed">Pagamento non riuscito</h1>
              <p className="text-[#786E65] mt-3" data-testid="order-failed-reason">{o.ultimo_errore || "Il pagamento è stato rifiutato o annullato."}</p>
              <Link to={`/checkout/${id}?t=${token}`} className="btn-primary mt-8" data-testid="retry-payment-btn">Riprova il pagamento</Link>
            </>
          ) : (
            <>
              <Loader2 size={48} className="mx-auto animate-spin text-[#7E5BAF]" />
              <h1 className="font-display text-3xl mt-4" data-testid="order-pending">Stiamo confermando il pagamento…</h1>
              <p className="text-[#786E65] mt-3">La gift card viene emessa appena Stripe conferma l'incasso.</p>
            </>
          )}
        </div>
        <div className="md:col-span-2"><Riepilogo o={o} /></div>
      </div>
    </Page>
  );
}
